import { Skeleton, Box, Grid2 } from "@mui/material"

const IntegrationModalSkeleton = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Grid2 container spacing={3}>
        {/* Basic Information Section Skeleton */}
        <Grid2 size={12}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={150} height={28} />
          </Box>

          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
          </Grid2>
        </Grid2>

        {/* Configuration Section Skeleton */}
        <Grid2 size={12}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={200} height={28} />
          </Box>

          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
            </Grid2>
          </Grid2>
        </Grid2>

        {/* Current Selection Display Skeleton */}
        <Grid2 size={12}>
          <Skeleton variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default IntegrationModalSkeleton
